import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

@Component({
    selector: 'lib-textarea-editor',
    standalone: true,
    imports: [CommonModule, FormsModule, MatIconModule],
    templateUrl: './textarea-editor.component.html',
    styleUrls: ['./textarea-editor.component.scss']
})
export class TextareaEditorComponent implements ICellEditorAngularComp, AfterViewInit, OnDestroy {
    private params!: ICellEditorParams & { placeholder: string; maxLength: number };
    
    public value!: string;
    public placeholder = '';
    public maxLength!: number;
    public showTooltip = false;
    public cellWidth = 0;

    @ViewChild('input') private readonly input!: ElementRef<HTMLTextAreaElement>;
    private onBodyScrollListener: (() => void) | undefined;

    ngAfterViewInit() {
        // The timeout ensures that the element is rendered before we try to focus it.
        setTimeout(() => this.input.nativeElement.focus());
    }

    agInit(params: ICellEditorParams & { placeholder: string; maxLength: number }): void {
        this.params = params;
        this.value = this.params.value;
        this.placeholder = this.params.placeholder || '';
        this.maxLength = this.params.maxLength;

        const cell = params.eGridCell;
        this.cellWidth = cell.clientWidth;

        // When the grid is scrolled, close the editor
        this.onBodyScrollListener = () => {
            this.params.api.stopEditing();
        };
        this.params.api.addEventListener('bodyScroll', this.onBodyScrollListener);
    }

    ngOnDestroy(): void {
        if (this.onBodyScrollListener) {
            this.params.api.removeEventListener('bodyScroll', this.onBodyScrollListener);
        }
    }

    getValue(): string {
        return this.value;
    }

    isPopup(): boolean {
        return true;
    }

    clearValue(event: Event): void {
        this.value = '';
        this.input.nativeElement.focus();
        event.stopPropagation();
    }
}
